import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Sparkles } from "lucide-react";

export default function ProtectedRoute({ children, allow }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-showty-cream">
        <Sparkles className="w-7 h-7 text-showty-red animate-pulse" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!user.role && location.pathname !== "/onboarding") return <Navigate to="/onboarding" replace />;
  if (user.role && location.pathname === "/onboarding") {
    const home = user.role === "manager" ? "/admin" : user.role === "ecommerce_admin" ? "/ecommerce" : user.role === "affiliator" ? "/affiliator" : "/creator";
    return <Navigate to={home} replace />;
  }
  if (allow && !allow.includes(user.role)) {
    const home = user.role === "manager" ? "/admin" : user.role === "ecommerce_admin" ? "/ecommerce" : user.role === "affiliator" ? "/affiliator" : "/creator";
    return <Navigate to={home} replace />;
  }
  return children;
}
